var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%","position":"absolute","inset-inline-start":"0","top":"0"}},[_c('img',{ref:"storybaordImagePreviewRef",staticStyle:{"width":"100%","height":"100%","position":"relative","z-index":"1"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }